const MONTH = {
    'JAN': 0, 'FEB': 1, 'MÄRZ': 2, 'APR': 3, 'MAI': 4, 'JUNI': 5,
    'JULI': 6, 'AUG': 7, 'SEPT': 8, 'OKT': 9, 'NOV': 10, 'DEZ': 11
};

function gigDate(g) {
    return new Date(parseInt(g.year), MONTH[g.month], parseInt(g.day));
}

function renderGig(g) {
    const alert = g.alert
        ? `<div class="alert absolute flex bg-alert items-center justify-center w-full text-center m-4 p-2 opacity-90 -rotate-6 bottom-8"><p class="mb-0 font-bold">${g.alert}</p></div>`
        : '';
    return `<div class="gig flex justify-start w-full mx-auto my-4 relative">
        <div class="date bg-primary p-2 min-w-32 aspect-square justify-center items-center flex flex-col">
            <h1 class="mb-0 font-regular text-4xl">${g.day}</h1>
            <h2 class="mb-0 font-regular text-2xl">${g.month}</h2>
        </div>
        <div class="info px-4 lg--px-8 flex flex-col justify-center">
            <h2 class="text-2xl lg--text-3xl leading-none font-bold">${g.location}</h2>
            <p class="mb-0">${g.city}</p>
        </div>
        ${alert}
    </div>`;
}

function renderGigOld(g) {
    const city = g.city ? `, ${g.city}` : '';
    return `<div class="gig-old past_gig flex w-full mx-auto my-2 relative">
        <p class="mb-0 text-lg"><strong>${g.day}. ${g.month} ${g.year}</strong> | ${g.location}${city}</p>
    </div>`;
}

document.addEventListener('DOMContentLoaded', function () {
    fetch('gigs.json')
        .then(r => r.json())
        .then(function (gigs) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const upcoming = gigs
                .filter(g => gigDate(g) >= today)
                .sort((a, b) => gigDate(a) - gigDate(b));

            const past = gigs
                .filter(g => gigDate(g) < today)
                .sort((a, b) => gigDate(b) - gigDate(a));

            const upcomingEl = document.getElementById('gigs-upcoming');
            if (upcomingEl) {
                upcomingEl.innerHTML = upcoming.length
                    ? upcoming.map(renderGig).join('')
                    : '<p class="col-span-2 text-center opacity-50 py-8">Neue Shows werden bald bekanntgegeben.</p>';
            }

            const pastEl = document.getElementById('gigs-past');
            if (pastEl && past.length) {
                pastEl.innerHTML = `<div class="spacer mt-12">
                        <h2 class="mb-0 font-regular">Vergangene <span class="font-bold">Shows</span></h2>
                    </div>
                    <div class="grid grid-cols-1">
                        ${past.map(renderGigOld).join('')}
                    </div>`;
            }
        });
});
